

















































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState, mapActions } from 'vuex';
import moment from 'moment';


import TitleBar from '@/components/Elements/TitleBar.vue'
import { STORE_KEY, store } from './_store';


@Component({
  computed: {
    ...mapState(STORE_KEY, [
      'loading', 'loaded', 'fatalError',

      'filter',

      'documents', 'lastMeta'
    ]),
  },
  components: {
    TitleBar
  }
})
export default class MixcartList extends Vue {
  moment: any = moment
  filter_created_at: any = null

  get titleStack () {
    return [
        'Заявки из микскарт'
    ]
  }

  get defaultSort() {
    return [this.$route.query.sortField || 'id', this.$route.query.sortDirection || 'desc']
  }

  onSort(field: string, direction: string) {
    console.log('onSort', field, direction)
    this.$router.replace({
      query: {
        ...this.$route.query, sortField: field, sortDirection: direction
      }
    })
  }

  private delayFilter: any = null
  private lastFilter: any = null

  onSearch(filter: any) {
    if (filter.created_at) {
      filter.created_at = moment(filter.created_at).format('YYYY-MM-DD')
    }
    this.lastFilter = filter
    if (!this.delayFilter) {
      setTimeout(() => {
        this.$router.replace({
          query: {
            ...this.$route.query, ...this.lastFilter
          }
        })
        this.delayFilter = null
      }, 1000)
    }
    this.delayFilter = filter
  }

  onPageChange(page: string) {
    console.log('onPageChange', page)
    this.$router.replace({
      query: { ...this.$route.query, page }
    })
  }

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }

  public mounted() {
    this.handleParamsChange();
  }

  beforeDestroy() {
    this.$store.unregisterModule(STORE_KEY);
  }

  // ---------------------------------------------------------------------------

  @Watch('$route.query')
  public handleParamsChange() {
    this.filter_created_at = (this as any).$route.query.created_at ? moment((this as any).$route.query.created_at).toDate() : null
    this.$store.dispatch(`${STORE_KEY}/loadData`, this.$route.query)
  }
}

